import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
  padding: 50px 20px;
`
